<template>
  <el-dialog
    title="修改专家序号"
    :visible.sync="visible"
    top="35vh"
    width="400px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading">
      <el-form
        ref="ruleForm"
        class="ruleForm"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="auto"
      >
        <el-form-item label="专家序号" prop="goalOrder">
          <el-input-number
            v-model="form.goalOrder"
            placeholder="请输入专家序号"
            :min="1"
            :max="maxSN"
            :step-strictly="true"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <p class="submit fn-text-center">
        <el-button type="primary" @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dataSN: {
      type: Number,
      required: true
    },
    maxSN: {
      type: Number,
      required: true
    }
  },
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      visible: true,
      form: {
        goalOrder: ""
      },
      rules: {
        goalOrder: [isEmpty("请输入专家序号")]
      },
      isLoading: false
    };
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.goalOrder === this.dataSN) {
            return this.$message.error("位置没有发生任何改变");
          }
          this.loadAddData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      this.$api("expert", "modExpertSN", {
        ...this.form,
        sourceOrder: this.dataSN
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
